import { Injectable } from '@angular/core';
import {Http, Headers, RequestOptions, Response } from '@angular/http';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { ApiConstant } from './../api.constant';



@Injectable()
export class RegisterService {
    user: any;
    private headers: Headers;
    private options: RequestOptions;
    private registerUrl : String;
    constructor(
        private apiservice: ApiConstant,
        private  http : Http
    ){
        this.registerUrl = apiservice.ServerWithApiUrl;
        this.headers = new Headers();
        this.headers.append('Access-Control-Allow-Origin', '*');
        this.headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
        this.headers.append('Content-Type', 'application/json');
        this.options = new RequestOptions({ headers: this.headers });
    }

    registerUser(user) {
        return this.http.post(this.registerUrl + 'register', JSON.stringify(user), this.options)
            .map((res: Response) => res.json());
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/register/register.service.ts